import React from 'react';
import { useTranslation } from 'react-i18next';

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <>
      <head>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
      </head>
      <section className="page-header">
        <div className="container">
          <h1>{t('privacy.title')}</h1>
          <p>{t('privacy.last_updated')}</p>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          <div className="content-section">
            <h2>{t('privacy.introduction.title')}</h2>
            <p>{t('privacy.introduction.text1')}</p>
            <p>{t('privacy.introduction.text2')}</p>
          </div>

          <div className="content-section">
            <h2>{t('privacy.information_collected.title')}</h2>
            
            <h3>{t('privacy.information_collected.personal.title')}</h3>
            <p>{t('privacy.information_collected.personal.text1')}</p>
            <ul>
              {(t('privacy.information_collected.personal.list1', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            
            <p>{t('privacy.information_collected.personal.text2')}</p>
            <ul>
              {(t('privacy.information_collected.personal.list2', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

            <h3>{t('privacy.information_collected.automatic.title')}</h3>
            <p>{t('privacy.information_collected.automatic.text')}</p>
            <ul>
              {(t('privacy.information_collected.automatic.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="content-section">
            <h2>{t('privacy.how_we_use.title')}</h2>
            <p>{t('privacy.how_we_use.text')}</p>
            <ul>
              {(t('privacy.how_we_use.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}><strong>{item.split(':')[0]}:</strong> {item.split(':').slice(1).join(':')}</li>
              ))}
            </ul>
          </div>

          <div className="content-section">
            <h2>{t('privacy.sharing.title')}</h2>
            <p>{t('privacy.sharing.text')}</p>
            
            <h3>{t('privacy.sharing.service_providers.title')}</h3>
            <p>{t('privacy.sharing.service_providers.text')}</p>
            
            <h3>{t('privacy.sharing.legal_requirements.title')}</h3>
            <p>{t('privacy.sharing.legal_requirements.text')}</p>
            
            <h3>{t('privacy.sharing.business_transfers.title')}</h3>
            <p>{t('privacy.sharing.business_transfers.text')}</p>
            
            <h3>{t('privacy.sharing.consent.title')}</h3>
            <p>{t('privacy.sharing.consent.text')}</p>
          </div>

          <div className="content-section">
            <h2>{t('privacy.data_security.title')}</h2>
            <p>{t('privacy.data_security.text')}</p>
            <ul>
              {(t('privacy.data_security.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <p>{t('privacy.data_security.disclaimer')}</p>
          </div>

          <div className="content-section">
            <h2>{t('privacy.data_retention.title')}</h2>
            <p>{t('privacy.data_retention.text')}</p>
          </div>

          <div className="content-section">
            <h2>{t('privacy.your_rights.title')}</h2>
            <p>{t('privacy.your_rights.text')}</p>
            <ul>
              {(t('privacy.your_rights.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}><strong>{item.split(':')[0]}:</strong> {item.split(':').slice(1).join(':')}</li>
              ))}
            </ul>
            <p>{t('privacy.your_rights.contact')}</p>
          </div>

          <div className="content-section">
            <h2>{t('privacy.cookies.title')}</h2>
            <p>{t('privacy.cookies.text1')}</p>
            <ul>
              {(t('privacy.cookies.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <p>{t('privacy.cookies.text2')}</p>
          </div>

          <div className="content-section">
            <h2>{t('privacy.third_party_links.title')}</h2>
            <p>{t('privacy.third_party_links.text')}</p>
          </div>

          <div className="content-section">
            <h2>{t('privacy.children_privacy.title')}</h2>
            <p>{t('privacy.children_privacy.text')}</p>
          </div>

          <div className="content-section">
            <h2>{t('privacy.international_transfers.title')}</h2>
            <p>{t('privacy.international_transfers.text')}</p>
          </div>

          <div className="content-section">
            <h2>{t('privacy.policy_changes.title')}</h2>
            <p>{t('privacy.policy_changes.text')}</p>
          </div>

          <div className="content-section">
            <h2>{t('privacy.contact_us.title')}</h2>
            <p>{t('privacy.contact_us.text')}</p>
            <ul>
              <li><strong>Correo Electrónico:</strong> privacy@molecorp.club</li>
              <li><strong>Dirección:</strong> MoleCorp, Presa Encimera, 48800 Balmaseda, España</li>
              <li><strong>CIF:</strong> B02789345</li>
            </ul>
            <p>{t('privacy.contact_us.response_time')}</p>
          </div>

          <div className="content-section">
            <h2>{t('privacy.compliance.title')}</h2>
            <p>{t('privacy.compliance.text')}</p>
            <ul>
              {(t('privacy.compliance.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="content-section">
            <h2>{t('privacy.ccpa_rights.title')}</h2>
            <p>{t('privacy.ccpa_rights.text')}</p>
            <ul>
              {(t('privacy.ccpa_rights.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}><strong>{item.split(':')[0]}:</strong> {item.split(':').slice(1).join(':')}</li>
              ))}
            </ul>
            <p>{t('privacy.ccpa_rights.contact')}</p>
          </div>

          <div className="content-section">
            <h2>{t('privacy.international_transfers_detailed.title')}</h2>
            <p>{t('privacy.international_transfers_detailed.text')}</p>
            <ul>
              {(t('privacy.international_transfers_detailed.list', { returnObjects: true }) || []).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default Privacy;